<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">
  <div class="tfq">

    <!-- Nav : quitter (la tentative se reprend plus tard) + progression -->
    <div class="tfq-nav">
      <button class="tfq-quit-btn" (click)="quit()">
        <i class="fa-solid fa-xmark"></i>
        <span translate>Quitter</span>
      </button>
      <div class="tfq-progress">
        <div class="tfq-progress-label">
          <span translate>Question</span> {{ question.index }}/{{ question.total }}
        </div>
        <div class="tfq-progress-track">
          <div class="tfq-progress-fill" [style.width.%]="progressPercent"></div>
        </div>
      </div>
    </div>

    <div class="tfq-body">

    <!-- Consigne (langue source) -->
    <div class="tfq-instruction mb-3" *ngIf="question.instruction">
      {{ question.instruction }}
    </div>

    <!-- Support de compréhension (texte ou audio, partagé entre plusieurs questions) -->
    <div class="tfq-support mb-3" *ngIf="question.support">
      <div class="tfq-support-text" *ngIf="question.support.translation">
        {{ question.support.translation }}
      </div>
      <div class="tfq-support-audio" *ngIf="question.support.audio">
        <button class="tfq-audio-btn" (click)="audioSrv.play(question.support.audio)">
          <i class="fa-solid fa-volume-high"></i>
          <span translate>Écouter</span>
        </button>
      </div>
      <img class="tfq-support-image" *ngIf="question.support.image" [src]="question.support.image | gameImage" alt=""/>
    </div>

    <!-- Titre éventuel -->
    <div class="tfq-title mb-2" *ngIf="question.title">
      {{ question.title }}
    </div>

    <!-- Énoncé (langue cible) -->
    <div class="tfq-question mb-3" *ngIf="question.translation">
      <!-- Phrase à trou : le [?] devient un emplacement visuel rempli par la réponse choisie -->
      <ng-container *ngIf="question.type === 'gap_fill'">
        <ng-container *ngFor="let part of gapParts; let last = last; trackBy: trackByIndex">
          <span>{{ part }}</span>
          <span class="tfq-gap" *ngIf="!last" [class.tfq-gap--filled]="selectedAnswer">{{ selectedAnswer?.translation }}</span>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="question.type !== 'gap_fill'">
        {{ question.translation }}
      </ng-container>
    </div>

    <!-- Audio / image de la question -->
    <div class="d-flex justify-content-center mb-3" *ngIf="question.audio">
      <button class="tfq-audio-btn" (click)="audioSrv.play(question.audio)">
        <i class="fa-solid fa-volume-high"></i>
        <span translate>Écouter</span>
      </button>
    </div>
    <div class="d-flex justify-content-center mb-3" *ngIf="question.image">
      <img class="tfq-image" [src]="question.image | gameImage" alt=""/>
    </div>

    <!-- Saisie libre (word_translation) -->
    <div class="tfq-free-input mb-3" *ngIf="question.freeInput">
      <input
        type="text"
        class="tfq-input"
        [(ngModel)]="freeText"
        (keyup.enter)="submit()"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        placeholder="{{ 'Ta réponse…' | translate }}"/>
    </div>

    <!-- Choix -->
    <div class="tfq-answers mb-3" *ngIf="!question.freeInput">
      <div
        class="tfq-answer"
        *ngFor="let answer of question.answers; trackBy: trackByIndex"
        (click)="selectAnswer(answer)"
        [class.tfq-answer--selected]="selectedAnswer && answer.uniqid === selectedAnswer.uniqid">
        <ng-container *ngIf="answer.translation">{{ answer.translation }}</ng-container>
        <i class="fa-solid fa-volume-high" *ngIf="!answer.translation && answer.audio"></i>
      </div>
    </div>

    <!-- Actions : pas de retour arrière, pas de feedback -->
    <div class="tfq-actions">
      <button class="tfq-btn-skip" (click)="skip()" [disabled]="submitting" translate>
        Je ne sais pas
      </button>
      <button class="tfq-btn-next" (click)="submit()" [disabled]="!canSubmit" translate>
        Valider
      </button>
    </div>

    </div>

  </div>
</ng-container>
